import React, { } from 'react'
import { View, Image, TouchableOpacity, ColorPropType } from 'react-native'
import PropTypes from 'prop-types'

import VfText from '../VfText'

import styles from './MigrationHeader.Styles'

function MigrationHeader(props) {

  const {
    leftIcon,
    leftLabel,
    onLeftPress,
    leftStyle,
    title,
    titlestyle,
    rightIcon,
    rightLabel,
    onRightPress,
    rightStyle,
    children,
    style,
    isContentLoading,
    loadingBackgroundColor,
    loadingForegroundColor
  } = props


  const renderIcon = icon => {
    if (icon === null) {
      return null
    }
    return <Image source={icon} style={styles.icon} />
  }

  return (
    <View style={[styles.wraper, style]}>
      <View style={styles.container}>
        <TouchableOpacity
          style={[styles.touchables, styles.leftBlock]}
          onPress={onLeftPress}>
          {renderIcon(leftIcon)}
          <VfText
            style={leftStyle}
            isLoading={isContentLoading}
            loadingBackgroundColor={loadingBackgroundColor}
            loadingForegroundColor={loadingForegroundColor}
            i18nKey={leftLabel} />
        </TouchableOpacity>
        <VfText
          size="h4"
          style={[
            styles.titleStyle,
            titlestyle
          ]}
          isLoading={isContentLoading}
          loadingBackgroundColor={loadingBackgroundColor}
          loadingForegroundColor={loadingForegroundColor}
          i18nKey={title}
        />
        <TouchableOpacity
          style={[styles.touchables, styles.rightBlock]}
          onPress={onRightPress}>
          <VfText
            style={[
              rightStyle
            ]}
            isLoading={isContentLoading}
            loadingBackgroundColor={loadingBackgroundColor}
            loadingForegroundColor={loadingForegroundColor}
            i18nKey={rightLabel}
          />
          {renderIcon(rightIcon)}
        </TouchableOpacity>
      </View>
      {children}
    </View>

  )
}
MigrationHeader.defaultProps = {
  leftIcon: null,
  rightIcon: null,
  title: '',
  leftLabel: '',
  rightLabel: ''
}

MigrationHeader.propTypes = {
  leftIcon: PropTypes.any,
  leftLabel: PropTypes.string,
  onLeftPress: PropTypes.func,
  leftStyle: PropTypes.object,
  title: PropTypes.string,
  titlestyle: PropTypes.object,
  rightIcon: PropTypes.any,
  rightLabel: PropTypes.string,
  onRightPress: PropTypes.func,
  rightStyle: PropTypes.object,
  children: PropTypes.any,
  style: PropTypes.object,
  isContentLoading: PropTypes.bool,
  loadingBackgroundColor: ColorPropType,
  loadingForegroundColor: ColorPropType
}

export default MigrationHeader
